import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InsertAhjFeeScheduleVariableMutationVariables = Types.Exact<{
  object: Types.Ahj_Fee_Schedule_Variables_Insert_Input;
}>;


export type InsertAhjFeeScheduleVariableMutation = { __typename?: 'mutation_root', insert_ahj_fee_schedule_variables_one?: { __typename?: 'ahj_fee_schedule_variables', id: any } | null };


export const InsertAhjFeeScheduleVariableDocument = gql`
    mutation insertAhjFeeScheduleVariable($object: ahj_fee_schedule_variables_insert_input!) {
  insert_ahj_fee_schedule_variables_one(object: $object) {
    id
  }
}
    `;
export type InsertAhjFeeScheduleVariableMutationFn = Apollo.MutationFunction<InsertAhjFeeScheduleVariableMutation, InsertAhjFeeScheduleVariableMutationVariables>;

/**
 * __useInsertAhjFeeScheduleVariableMutation__
 *
 * To run a mutation, you first call `useInsertAhjFeeScheduleVariableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertAhjFeeScheduleVariableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertAhjFeeScheduleVariableMutation, { data, loading, error }] = useInsertAhjFeeScheduleVariableMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsertAhjFeeScheduleVariableMutation(baseOptions?: Apollo.MutationHookOptions<InsertAhjFeeScheduleVariableMutation, InsertAhjFeeScheduleVariableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertAhjFeeScheduleVariableMutation, InsertAhjFeeScheduleVariableMutationVariables>(InsertAhjFeeScheduleVariableDocument, options);
      }
export type InsertAhjFeeScheduleVariableMutationHookResult = ReturnType<typeof useInsertAhjFeeScheduleVariableMutation>;
export type InsertAhjFeeScheduleVariableMutationResult = Apollo.MutationResult<InsertAhjFeeScheduleVariableMutation>;
export type InsertAhjFeeScheduleVariableMutationOptions = Apollo.BaseMutationOptions<InsertAhjFeeScheduleVariableMutation, InsertAhjFeeScheduleVariableMutationVariables>;